module.exports = __webpack_public_path__ + "img/commissions.2e80c636.svg";